import React from "react";
import {useTranslation} from "react-i18next";
import Tag, {TagSize, TagStyle} from "./Tag";
import {TranslationLibFile, TranslationLibKey} from "../../utils/locale";

type TagNewProps = {
    size?: TagSize;
    style?: TagStyle;
    cssClass?: string;
}

const TagNew: React.FC<TagNewProps> = (props) => {
    const {t} = useTranslation(TranslationLibFile.COMMON);

    return (
        <Tag
            label={t(TranslationLibKey.LABEL_NEW)}
            style={TagStyle.PRIMARY_CYAN_LIGHT}
            size={TagSize.XSMALL}
            {...props}
        />
    );
};

export default TagNew;
